import { Bid } from 'modules/domain/bid/types'
import { SlugLabelPair } from 'modules/domain/common/types'
import { FC, useState } from 'react'
import { WrapperBoard } from 'views/components/Board/styled'
import { UserBidsObj } from '../useUserBids'
import { BidsColumn } from './BidsColumn/BidsColumn'
import { MatchesColumn } from './MatchesColumn/MatchesColumn'
import { ResponsesColumn } from './ResponsesColumn/ResponsesColumn'

type Props = {
  reasons: SlugLabelPair[]
  bids: UserBidsObj
}

export const Board: FC<Props> = ({ reasons, bids }) => {
  const [activeBid, setActiveBid] = useState<Bid>()

  return (
    <WrapperBoard>
      <BidsColumn setActiveBid={setActiveBid} activeBid={activeBid} bids={bids} />
      <MatchesColumn activeBid={activeBid} reasons={reasons} />
      <ResponsesColumn activeBid={activeBid} reasons={reasons} />
    </WrapperBoard>
  )
}
